module.exports = __webpack_public_path__ + "img/bingo_ball-67.33a319b1.png";